import React, { useEffect, useState } from "preact/compat";
import { AffLinkProps } from "./affLink.type";
import { detectAdBlock } from '../../../helper/detectAdBlock';

export const AffLink = ({
  className,
  site,
  url,
  aalink,
  type,
  size = '',
  disabled = false,
  children
}: AffLinkProps) => {
  const [adBlock, setAdBlock] = useState(detectAdBlock());

  useEffect(() => {
    setAdBlock(detectAdBlock())
  }), [setAdBlock];
  
  return (
    <a 
        className={`${type !== 'link-underline-primary' ? 'btn btn-'+type : type} ${size !== '' && type !== 'link-underline-primary' ? 'btn-'+size : ''} ${className}`} 
        href={url} 
        target={`${adBlock ? '_self' : '_blank'}`}
        rel='nofollow' 
        data-aatracker={site === "sbr" ? aalink : ''}
        data-linkcont={site === "covers" ? aalink : ''}
        disabled ={disabled}>
        {children}
    </a>
  )
}